import React from 'react';
import ReactECharts from 'echarts-for-react';

const MacroChart = ({ macros, theme }) => {
  const isDark = theme === 'dark';
  
  const option = {
    tooltip: {
      trigger: 'item'
    },
    legend: {
      bottom: '0%',
      left: 'center',
      textStyle: {
        color: isDark ? '#e5e7eb' : '#374151'
      }
    },
    series: [
      {
        name: 'Macros',
        type: 'pie',
        radius: ['40%', '70%'],
        avoidLabelOverlap: false,
        itemStyle: {
          borderRadius: 10,
          borderColor: isDark ? '#1f2937' : '#fff',
          borderWidth: 2
        },
        label: {
          show: false,
          position: 'center'
        },
        emphasis: {
          label: {
            show: true,
            fontSize: 20,
            fontWeight: 'bold',
            color: isDark ? '#fff' : '#000'
          }
        },
        labelLine: {
          show: false
        },
        data: [
          { value: macros.protein.cal, name: 'Protein', itemStyle: { color: '#3b82f6' } }, // Blue
          { value: macros.carbs.cal, name: 'Carbs', itemStyle: { color: '#10b981' } },    // Emerald
          { value: macros.fat.cal, name: 'Fat', itemStyle: { color: '#f59e0b' } }        // Amber
        ]
      }
    ]
  };

  return <ReactECharts option={option} style={{ height: '300px', width: '100%' }} />;
};

export default MacroChart;